import moment from "moment";
import React from "react";

import { CalendarSelectProps, MonthSelector } from "../../month_selector";
import css from "./calendar_header.module.scss";
import { ChangeMonthButton } from "./change_month_button";

type CalendarNavigationProps = CalendarSelectProps & {
  showArrows?: boolean;
  label?: string;
};

export const CalendarNavigation = ({
  label,
  showArrows,
  displayMonth,
  minDate = moment.utc().subtract(100, "years").toISOString(),
  maxDate = moment.utc().add(100, "years").toISOString(),
  setDisplayMonth
}: CalendarNavigationProps): JSX.Element => {
  const selectProps = { minDate, maxDate, displayMonth, setDisplayMonth };
  const buttonProps = { displayMonth, setDisplayMonth };
  return (
    <div className={css.title}>
      {label && <strong data-qa-id="CalendarHeader.label">{label}</strong>}
      <MonthSelector {...selectProps} className={css.monthSelector} />

      {showArrows && (
        <div className={css.arrowsContainer}>
          <ChangeMonthButton
            {...buttonProps}
            direction="prev"
            dateLow={displayMonth}
            dateHigh={moment(minDate)}
          />
          <div className={css.separator} />
          <ChangeMonthButton {...buttonProps} direction="next" dateLow={maxDate} dateHigh={displayMonth} />
        </div>
      )}
    </div>
  );
};
